import React, { useState } from 'react';
import { size } from 'lodash';
import { Dialog, DialogContent, DialogTitle, Typography, Tooltip, IconButton } from '@mui/material';
import { Close as CloseIcon, FileCopy } from '@mui/icons-material';

const closeBtnStyles = {
  position: 'absolute',
  right: 0,
  top: 0,
  margin: '8px',
};

export function ChargerConfigurationModifiedNodeIndicator(props) {
  const { updatedModuleFields, nodeName, isModal } = props;
  const [isOpen, setIsOpen] = useState(false);

  const close = () => setIsOpen(false);

  const open = () => setIsOpen(true);

  const updatedModuleFieldsCount = size(updatedModuleFields);

  if (!updatedModuleFieldsCount) {
    return <div />;
  }

  return (
    <>
      <Tooltip title="Click to view modified values">
        <div className="updated-node-count-icon" onClick={open}>
          {updatedModuleFieldsCount}
        </div>
      </Tooltip>
      <Dialog open={isOpen} fullWidth maxWidth="lg" onClose={close}>
        <DialogTitle>
          <Typography variant="h6">{nodeName}</Typography>
          <IconButton size="large" onClick={close} style={closeBtnStyles}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <div className="modified-params">
            <div className="modified-params-headline">
              <div className="modified-params-cell param-name">Node Name {'>'} Parameter Name</div>
              <div className="modified-params-cell param-value">Modified Value</div>
              {!isModal && <div className="modified-params-cell param-current-value">Current Value</div>}
            </div>
            <div className="modified-params-body">
              {updatedModuleFields.map((param) => (
                <div key={param.name} className="modified-params-row">
                  <div className="modified-params-cell param-name">
                    <Tooltip title={param.status}>
                      <div className={`parameter-status-marker ${param.status}`} />
                    </Tooltip>
                    {param.name}
                  </div>
                  <div className="modified-params-cell param-value">
                    <Tooltip title="Click to copy">
                      <FileCopy
                        onClick={() => {
                          navigator.clipboard.writeText(param.value);
                        }}
                      />
                    </Tooltip>
                    {param.value}
                  </div>
                  {!isModal && (
                    <div className="modified-params-cell param-current-value">
                      <Tooltip title="Click to copy">
                        <FileCopy
                          onClick={() => {
                            navigator.clipboard.writeText(param.currentValue);
                          }}
                        />
                      </Tooltip>
                      {param.currentValue}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
